module.exports = __webpack_public_path__ + "img/l3.a5f200f1.png";